import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

// import registerServiceWorker from './registerServiceWorker';
// TODO: This is not working properly with SSL

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
